var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useMemo, useRef } from 'react';
import { MenuOutlined, SettingsOutlined } from '@udesk/icons';
import { Button, Checkbox, Popover, Transfer } from 'udesk-ui';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from '../../utils/array/array-move';
import styled from 'styled-components';
var DragHandle = SortableHandle(function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-unordered-list"
  }, /*#__PURE__*/React.createElement(MenuOutlined, null));
});
var SortableItem = SortableElement(function (_ref) {
  var selectedKeys = _ref.selectedKeys,
    item = _ref.item,
    onItemSelect = _ref.onItemSelect;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '6px 12px',
      lineHeight: '20px',
      transition: 'all 0.3s',
      zIndex: 1031
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      flex: 1
    },
    onChange: function onChange(e) {
      onItemSelect(item.key, e.target.checked);
    },
    checked: selectedKeys.includes(item.key)
  }, item.title), /*#__PURE__*/React.createElement(DragHandle, null)));
});
var SortableList = SortableContainer(function (_ref2) {
  var list = _ref2.list,
    selectedKeys = _ref2.selectedKeys,
    onItemSelect = _ref2.onItemSelect;
  return /*#__PURE__*/React.createElement("ul", null, list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SortableItem, {
      key: item.key,
      index: index,
      item: item,
      selectedKeys: selectedKeys,
      onItemSelect: onItemSelect
    });
  }));
});
var ColumnsControlTransfer = function ColumnsControlTransfer(props) {
  var dataSource = props.dataSource,
    showColumnKeys = props.showColumnKeys,
    onChangeProps = props.onChange,
    getContainer = props.getContainer;
  var onChange = function onChange(targetKeys) {
    onChangeProps === null || onChangeProps === void 0 ? void 0 : onChangeProps(targetKeys);
  };
  var onSortChange = function onSortChange(filteredItems) {
    onChange(filteredItems.map(function (i) {
      return i.key;
    }));
  };
  return /*#__PURE__*/React.createElement(Transfer, {
    dataSource: dataSource,
    targetKeys: showColumnKeys,
    onChange: onChange,
    render: function render(item) {
      return item.title;
    },
    showSearch: true,
    filterOption: function filterOption(inputValue, option) {
      var _option$title;
      return option === null || option === void 0 ? void 0 : (_option$title = option.title) === null || _option$title === void 0 ? void 0 : _option$title.includes(inputValue);
    }
  }, function (_ref3) {
    var direction = _ref3.direction,
      onItemSelect = _ref3.onItemSelect,
      selectedKeys = _ref3.selectedKeys,
      filteredItems = _ref3.filteredItems;
    if (direction === 'right') {
      return /*#__PURE__*/React.createElement(SortableList, {
        list: filteredItems,
        onSortChange: onSortChange,
        selectedKeys: selectedKeys,
        onItemSelect: onItemSelect,
        onSortEnd: function onSortEnd(_ref4) {
          var oldIndex = _ref4.oldIndex,
            newIndex = _ref4.newIndex;
          var res = arrayMoveImmutable(showColumnKeys, oldIndex, newIndex);
          onChange(res);
        },
        getContainer: getContainer,
        useDragHandle: true
      });
    }
  });
};
var ColumnsControlTransferWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ul {\n    padding: 0;\n    margin: 0;\n  }\n"])));
var ColumnsControl = function ColumnsControl(props) {
  var columns = props.columns,
    showColumnKeys = props.showColumnKeys,
    onChange = props.onChange;
  var dataSource = useMemo(function () {
    var _columns$map;
    return (_columns$map = columns === null || columns === void 0 ? void 0 : columns.map(function (i) {
      return {
        title: i.title,
        key: i.key
      };
    })) !== null && _columns$map !== void 0 ? _columns$map : [];
  }, [columns]);
  var ref = useRef(null);
  return /*#__PURE__*/React.createElement(Popover, {
    placement: "bottomRight",
    //   visible={true}
    content: /*#__PURE__*/React.createElement(ColumnsControlTransferWrap, {
      ref: ref
    }, /*#__PURE__*/React.createElement(ColumnsControlTransfer, {
      dataSource: dataSource,
      showColumnKeys: showColumnKeys,
      onChange: onChange,
      getContainer: function getContainer() {
        return ref.current || document.body;
      }
    })),
    trigger: "click",
    arrowPointAtCenter: true
  }, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(SettingsOutlined, {
      style: {
        marginRight: 4,
        fontSize: '16px'
      }
    })
  }, "\u5217"));
};
export default ColumnsControl;